import React from 'react';
import { isIOS } from 'react-device-detect';

import { printMissingConfigError, SiteConfigManager } from '@atlas/core';

import StaticBlock from 'common/StaticBlock/StaticBlock';

import MenuFooterItem from './MenuFooterItem';

const FooterMobileApplicationLink = () => {
  const showInFooter = SiteConfigManager.getConfig('config.config.applicationLink.showInFooter');
  const footerBlock = SiteConfigManager.getConfig('config.config.applicationLink.footerBlock');
  const url = SiteConfigManager.getConfig('config.config.applicationLink.url');

  if (showInFooter && (!footerBlock || !url)) {
    printMissingConfigError('config.config.applicationLink[footerBlock|url]');
  }

  if (!showInFooter || isIOS) return null;

  const mobApplicationTitle = showInFooter ? 'footer_title_get_the_app' : null;

  return (
    <MenuFooterItem className="footer-mobile-application" title={mobApplicationTitle}>
      <a
        aria-label="mobile-application"
        className="footer-mobile-application__link"
        href={url}
        rel="noreferrer"
        target="_blank"
      >
        <StaticBlock options={{ source: footerBlock }} />
      </a>
    </MenuFooterItem>
  );
};

export default FooterMobileApplicationLink;
